import { createErrorHandler } from '@sentry/angular';
import { ErrorHandlerOptions } from '@sentry/angular/dist/errorhandler';
import { Logger } from '@patientlynk3/services';
import { SwUpdate } from '@angular/service-worker';
import { EMPTY, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

const _options = {
  logErrors: window.location.hostname === 'localhost'
} as ErrorHandlerOptions;

export function AbartysErrorHandlerFactory(swUpdate: SwUpdate, options: ErrorHandlerOptions = {}) {
  const defaultErrorHandler = createErrorHandler({
    ..._options,
    ...options
  });

  const handleError = defaultErrorHandler.handleError.bind(defaultErrorHandler);
  defaultErrorHandler.handleError = function newHandleError(error: Error & { originalStack }) {
    if (/Loading chunk (.*) failed/.test(error.message)) {
      Logger.error('Failed to load chunk. Forcing reload to fetch the latest version.', error);

      of(true).pipe(
        switchMap(() => swUpdate.checkForUpdate()),
        switchMap(() => swUpdate.versionUpdates),
        switchMap(() => swUpdate.activateUpdate()),
        switchMap(() => swUpdate.activateUpdate()),
        catchError(() => EMPTY),
      ).subscribe(_ => window.location.reload());

      return;
    }

    // Clean up Error stack trace from external code (eg. Angular/Zone.)
    error.stack = error.stack
      ?.split('\n')
      .filter(trace => !/(vendor|polyfills|runtime).js/.test(trace))
      .join('\n');

    error.originalStack = error.originalStack
      ?.split('\n')
      .filter(trace => !/(vendor|polyfills|runtime).js/.test(trace))
      .join('\n');

    handleError(error);
  };

  return defaultErrorHandler;
}
